import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuplicate = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "32px",
	height: "32px",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "icons-/-duplicate",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(4.000000, 4.000000)",
			id: "layers-back",
			stroke: "#006db8",
			strokeWidth: 1.5,
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle-path",
				x: .75,
				y: .75,
				width: 18,
				height: 18,
				rx: 1.5
			}), /* @__PURE__ */ _jsx("path", {
				d: "M21.75,5.25 C22.5784271,5.25 23.25,5.92157288 23.25,6.75 L23.25,21.75 C23.25,22.5784271 22.5784271,23.25 21.75,23.25 L6.75,23.25 C5.92157288,23.25 5.25,22.5784271 5.25,21.75",
				id: "Shape"
			})]
		}) })
	})]
});
const ForwardRef = forwardRef(SvgDuplicate);
export default ForwardRef;
